export const CloseIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Close</title>
      <path d="M14 2L2 14" stroke="#636363" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 14L2 2" stroke="#636363" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
